var ActionBarAlign = {
  Left: "left",
  Center: "center",
  Right: "right"
};
var ActionBarVerticalAlign = {
  Top: "top",
  Middle: "middle",
  Bottom: "bottom",
  Stretch: "stretch"
};

export { ActionBarAlign, ActionBarVerticalAlign };
